import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

function ThankYouPage() {
    const navigate = useNavigate();

    return (
        <div className="py-5 bg-light">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={8} md={10}>
                        <Card className="border-0 shadow-sm text-center p-5">
                            <Card.Body>
                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle p-3 mb-4">
                                        <CheckCircle size={50} className="text-success" />
                                    </div>
                                    <h1 className="display-5 fw-bold mb-3" style={{ background: 'linear-gradient(135deg, #6cc3f4 0%, #80abe9 50%, #b26dcd 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Thank You!</h1>
                                    <p className="lead mb-4">
                                        Your demo request has been successfully submitted. One of our healthcare solution specialists will contact you within 24 hours to schedule your personalized demo.
                                    </p>
                                </div>

                                <hr className="my-4" />

                                <div>
                                    <Button
                                        variant="primary"
                                        className="rounded-pill"
                                        onClick={() => navigate('/', { replace: true })}
                                        style={{ background: 'linear-gradient(135deg, #6cc3f4 0%, #80abe9 50%, #b26dcd 100%)', border: 'none' }}
                                    >
                                        Return to Homepage
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ThankYouPage;